// extracted by mini-css-extract-plugin
export default {"banner":"banner-module_banner__LkFg","header":"banner-module_header_PZ1Dg","sub-header":"banner-module_sub-header_qvKrZ"};